module.exports = __webpack_public_path__ + "static/img/t23.a1850e68.png";